export default "/images/vendor/flag-icon-css/flags/1x1/ie.svg?1b0ac4e772c2e62aef2f4646a46ab03f";